// @flow

import { nationalLineHaulActions } from './nlhActionCreator';

const initialState = {
  fetching: null,
  fetched: null
};

const nationalLineHaulReducers = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case nationalLineHaulActions.GET_NETWORK_STATE: {
      return Object.assign({}, state, action.payload);
    }
    case nationalLineHaulActions.GET_NETWORK_STATE_CHANGE: {
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};

export default nationalLineHaulReducers;
